var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreeDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.27359 10C4.27359 8.84377 3.31919 7.91669 2.12089 7.91669C0.954401 7.91669 0 8.84377 0 10C0 11.1563 0.954401 12.0834 2.12089 12.0834C3.31919 12.0834 4.27359 11.1563 4.27359 10ZM12.1209 10C12.1209 8.84377 11.1771 7.91669 10 7.91669C8.83351 7.91669 7.88971 8.84377 7.88971 10C7.88971 11.1563 8.83351 12.0834 10 12.0834C11.1771 12.0834 12.1209 11.1563 12.1209 10ZM20 10C20 8.84377 19.0562 7.91669 17.8791 7.91669C16.6808 7.91669 15.737 8.84377 15.737 10C15.737 11.1563 16.6808 12.0834 17.8791 12.0834C19.0562 12.0834 20 11.1563 20 10Z",
    fill: "#9C85F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/threeDots.b64d9096dcbce43dfb092a2938b1f83d.svg";
export { ForwardRef as ReactComponent };